
import { mapGetters } from 'vuex'
import RegistrationStepOne from '~/components/Registration/RegistrationStepOne'
import RegistrationStepTwo from '~/components/Registration/RegistrationStepTwo'
import RegistrationStepThree from '~/components/Registration/RegistrationStepThree'
import RegistrationStepFour from '~/components/Registration/RegistrationStepFour/index.vue'
import RegistrationStepFive from '~/components/Registration/RegistrationStepFive/index.vue'
import RegistrationStepSix from '~/components/Registration/RegistrationStepSix/index.vue'
import TermsAndConditionsDialog from '~/components/Dialogs/TermsAndConditionsDialog'
import PromoCode from '~/components/Registration/PromoCode/index.vue'
import { isGroupSubDomain } from '~/helpers/user'
import { isHavingProps } from '~/ZenOne-StoryBook/helpers/object'
import { switchLocation } from '~/helpers/practiceLocation'


export default {
  name: 'Registration',
  components: {
    PromoCode,
    RegistrationStepSix,
    RegistrationStepFive,
    RegistrationStepFour,
    RegistrationStepOne,
    RegistrationStepTwo,
    RegistrationStepThree,
    TermsAndConditionsDialog
  },
  data() {
    return {
      step: 1,
      userData: {},
      totalSteps: 5,
      valid: false,
      ready: false,
      stepMap: {
        1: 'stepOne',
        2: 'stepTwo',
        3: 'stepThree',
        4: 'stepFour',
        5: 'stepFive',
        6: 'stepSix'
      }
    }
  },
  async created() {
    this.step = await this.getInitialStep()
    this.ready = true
  },
  computed: {
    ...mapGetters({
      showFullScreenLoader: 'ui/showFullScreenLoader',
      user: 'user/user'
    }),
    nextBtnEnabled() {
      return this.valid || this.step === 4
    },
    hideBackBtn() {
      return this.step === 1 || this.step === 3 || this.step === 6
    },
    nextBtnText() {
      const trialDays = this.user?.practiceLocation?.trialPeriod ?? 14
      return this.step !== 6
        ? 'Next Step'
        : (isGroupSubDomain() ? 'Start my Membership' : `Start My ${trialDays}-days free trial`)
    },
    olderLocation() {
      return this.user?.practiceLocations?.find((pl) => pl.id < this.user?.practiceLocation?.id && pl.name)
    }
  },
  methods: {
    switchBack() {
      switchLocation(this.olderLocation.id, this.$router, this.$store)
    },
    async getInitialStep() {
      if (!this.$auth.user?.id) return 1

      await this.$store.dispatch('user/SetUserPracticeLocation')

      const pl = this.user.practiceLocation
      if (!pl || !pl.name || !isHavingProps(pl.params) || !pl.params.phone || !pl.params.card?.number || !isHavingProps(pl.address) || !isHavingProps(pl.billingAddress))
        return 3

      if (!this.user.emailConfirmed)
        return 5

      return 6
    },
    async nextBtnClickHandler() {
      const stepAlias = this.stepMap[this.step]

      this.$ga.event({
        eventCategory: 'registration',
        eventAction: 'click',
        eventLabel: stepAlias,
        eventValue: 1
      })

      const res = await this.$refs[stepAlias].nextBtnClickHandler()
      if (res) {
        this.valid = false
        this.userData = res
        this.step++
      }
    },
    backBtnClickHandler() {
      this.step--
    }
  }
}
